import UsersPartner from "@/pages/partner/Users";
import PartnerReports from "@/pages/partner/Reports";
import Tier2PartnerReports from "@/pages/partner/report/Tier2PartnerReports";
import PartnerCustomerReports from "@/pages/partner/report/PartnerCustomerReports";
import CustomerReports from "@/pages/partner/report/CustomerReports";
import CustomerUserReports from "@/pages/partner/report/CustomerUserReports";
import CustomerCourseReports from "@/pages/partner/report/CustomerCourseReports";
import CustomerCourseUserReports from "@/pages/partner/report/CustomerCourseUserReports";
import CustomerGroupReports from "@/pages/partner/report/CustomerGroupReports";
import CustomerPlaylistReports from "@/pages/partner/report/CustomerPlaylistReports";
import Tier2Partner from "@/pages/partner/Tier2Partners";
import PartnerDetails from "@/pages/partner/PartnerDetails";
import Tier2PartnerDetails from "@/pages/partner/report/Tier2PartnerDetails";
import PartnerReferralURL from "@/pages/partner/ReferralUrl";
import PartnerAccountManager from "@/pages/partner/AccountManager";
import CoursesPartner from "@/pages/partner/Courses";
import ManageCourse from "@/pages/partner/Managecourse";
import TestPartner from "@/pages/partner/course/TestPartner";
import Company from "@/pages/partner/Company";
import CourseReportDetails from "@/pages/partner/report/CourseDetails";
import PartnerNotification from "@/pages/partner/Notification";
import UserCourseReportDetails from "@/pages/partner/report/UserCourseReportDetails"; 

const routes = [
  {
    path: "/partner/users",
    name: "Users Partner",
    component: UsersPartner,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Customer",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports",
    name: "Partner Reports",
    component: PartnerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer",
    name: "Partner Customer Reports",
    component: PartnerCustomerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer/:id",
    name: "Customer Reports",
    component: CustomerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer/:id/user",
    name: "Single Customer Reports",
    component: CustomerUserReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer/:id/course",
    name: "Partner Customer Course Reports",
    component: CustomerCourseReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer/:id/course/:courseid/users",
    name: "Partner Course Reports",
    component: CustomerCourseUserReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer/:id/groups",
    name: "Groups Reports",
    component: CustomerGroupReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/customer/:id/playlist",
    name: "Partner Playlist Reports",
    component: CustomerPlaylistReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/partner",
    name: "Tier 2 Partner Reports",
    component: Tier2PartnerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Reports",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/tier2partners",
    name: "Tier Two Partner",
    component: Tier2Partner,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Tier Two Partner",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/tier/:id",
    name: "Partner Details",
    component: PartnerDetails,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Tier Two Partner",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/:id",
    name: "Tier 2 Partner Details",
    component: Tier2PartnerDetails,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Reports",
          disabled: false,
          href: "partner/reports"
        },
        {
          text: "Tier Two Partner",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/referral",
    name: "Referral Link",
    component: PartnerReferralURL,
    meta: {
      breadcrumb: [
        {
          text: "Referral Link",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/account-manager",
    name: "Account Manager",
    component: PartnerAccountManager,
    meta: {
      breadcrumb: [
        {
          text: "Account Manager",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/courses",
    name: "Courses Partner",
    component: CoursesPartner,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/courses"
        },
        {
          text: "Courses",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/courses/:id",
    name: "Partner Manage Course",
    component: ManageCourse,
    meta: {
      breadcrumb: [
        {
          text: "Customer",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/partner/courses"
        },
        {
          text: "Manage Course",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/courses/test/:id",
    name: "Partner Manage Courses",
    component: TestPartner,
    meta: {
      breadcrumb: [
        {
          text: "Customer",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/partner/courses"
        },
        {
          text: "Test Partner",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/company",
    name: "Partner Company",
    component: Company,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/company"
        },
        {
          text: "Company",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/course/:id",
    name: "Partner Course Reports",
    component: CourseReportDetails,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Course Details",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/notification/:id",
    name: "Partner Notification Settings",
    component: PartnerNotification,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Notification Settings",
          disabled: true
        }
      ],
      public: false,
      partner: true
    }
  },
  {
    path: "/partner/reports/:customer_id/user/:id",
    name: "Partner User Course Reports",
    component: UserCourseReportDetails,
    meta: {
      breadcrumb: [
        {
          text: "Partner",
          disabled: false,
          href: "/partner/users"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/partner/reports"
        },
        {
          text: "Customer Reports",
          disabled: false,
          href: "/partner/reports/customer"
        },
        {
          text: "Course Details",
          disabled: true
        }

      ],
      public: false,
      partner: true
    }
  },
];

export default routes;
